<template>
  <div class="indexActivity">
    <div class="activityContent">
      <img :src="activityDetial.exhNavImg" />
      <div>
        <h2>{{ activityDetial.name }}</h2>
        <p>时间：{{ activityDetial.makeDateStr }}</p>
        <p>地点：{{ activityDetial.areaAddress }}</p>
        <div>
          <p>简介：</p>
          <p>{{ activityDetial.exhRemark }}</p>
        </div>
      </div>
    </div>
    <div class="otherInfo">
      <div class="orderDetial">
        <div class="time">
          <p>
            <span> <i class="el-icon-folder-checked"></i>预约时间: </span>
            <span>{{ activityDetial.makeDateStr }}</span>
          </p>
          <p>
            <span> <i class="el-icon-location-outline"></i>签到时间: </span>
            <span>{{
              activityDetial.signType == "0"
                ? "未签到"
                : activityDetial.signType == "1"
                ? "无需签到"
                : "已签到"
            }}</span>
          </p>
          <!-- <p>
            <span>
              <i class="el-icon-time"></i>签退时间:
            </span>
            <span>{{orderDetial.outTime==''?'暂未签退':orderDetial.outTime}}</span>
          </p>-->
        </div>
        <div class="peopleList">
          <div class="title">
            <p>随行人员</p>
            <p>共&nbsp;{{ size || activityDetial.totalCount }}&nbsp;人</p>
          </div>
          <div class="content">
            <div class="title">
              <p v-show="isShow('fullName')">姓名</p>
              <p v-show="isShow('carType')">证件类型</p>
              <p v-show="isShow('cardNum')">证件号码</p>
              <p v-show="isShow('unit')">单位</p>
              <p v-show="isShow('username')">学号</p>
            </div>
            <div class="items">
              <div
                v-for="(item, index) in peopleList"
                :key="index"
                class="item"
              >
                <p v-show="isShow('fullName')">{{ item.fullName }}</p>
                <p v-show="isShow('carType')">
                  {{ item.carType == "0" ? "居民身份证" : "护照" }}
                </p>
                <p v-show="isShow('cardNum')">{{ item.cardNum }}</p>
                <p v-show="isShow('unit')">{{ item.unit }}</p>
                <p v-show="isShow('username')">{{ item.username }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="commentList">
        <div class="time">
          <p>
            <span> <i class="el-icon-s-custom"></i>所属团队: </span>
            <span>{{ activityDetial.personFrom }}</span>
          </p>
          <!-- <p>
            <span> <i class="el-icon-user"></i>人数: </span>
            <span>{{ activityDetial.totalCount }}</span>
          </p> -->
          <p>
            <span> <i class="el-icon-phone"></i>联系电话: </span>
            <span>{{ activityDetial.phone }}</span>
          </p>
        </div>
        <div class="title">
          <p>展览评论</p>
          <!-- <p class="addComment" v-if="activityDetial.signType !=0" @click="addComment"> -->
          <p class="addComment" @click="addComment()">
            写评论
            <i class="el-icon-edit"></i>
          </p>
        </div>
        <div class="content">
          <div
            class="comment"
            v-for="(item, index) in comment.list"
            :key="item.id"
          >
            <div class="info">
              <el-avatar
                :size="avatar.size"
                :src="item.headImgUrl ? item.headImgUrl : avatar.circleUrl"
                class="avator"
              ></el-avatar>
              <p class="name">{{ item.fullName }}</p>
              <p>评分: {{ item.score }}分</p>
            </div>
            <div class="descri">
              <p>{{ item.content }}</p>
            </div>
            <div class="comment-time">
              <p>{{ item.createdDate }}</p>
              <p class="commont-button" @click="addComment(item.id)">回复</p>
            </div>
            <div
              v-show="item.hfNum > 0 && !item.isShow"
              class="comment-list-wrap"
              @click="getCommont(item.id, index)"
            >
              展开更多回复
              <i class="el-icon-caret-bottom"></i>
            </div>
            <template v-if="item.hfNum > 0 && item.isShow">
              <div
                class="commont-children-item"
                v-for="(el, index) of item.list"
                :key="index"
              >
                <div class="info">
                  <el-avatar
                    :size="avatar.size"
                    :src="el.headImgUrl ? el.headImgUrl : avatar.circleUrl"
                    class="avator"
                  ></el-avatar>
                  <p class="name">{{ el.fullName }}</p>
                  <p>评分: {{ el.score }}分</p>
                </div>
                <div class="descri">
                  <p>{{ el.content }}</p>
                </div>
                <div class="comment-time">
                  <p>{{ el.createdDate }}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- <el-pagination
          :page-size="comment.pageSize"
          :pager-count="13"
          class="customPage"
          layout="prev, pager, next"
          :total="comment.totalCount"
          @current-change="getCommentList"
        ></el-pagination> -->
      </div>
      <el-dialog
        title="活动评论"
        :visible.sync="comment.commentShow"
        width="30%"
        class="commentModal"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="星级评价" prop="star">
            <el-rate v-model="ruleForm.star"></el-rate>
          </el-form-item>
          <el-form-item label="文字评价" prop="text">
            <el-input type="textarea" v-model="ruleForm.text"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_comment">立即评论</el-button>
            <el-button @click="addComment()">返回</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  findAllFollowPageByMakeId,
  getFollowData,
  getCommont,
  orderDetial,
  getMyActivityComment,
  comment
} from "@/libs/api";
import Moment from "moment";
export default {
  data() {
    return {
      commontId: "",
      followFieldDTOList: [],
      hallId: this.$route.params.activityId,
      orderId: this.$route.params.orderId,
      orderDetial: {},
      activityDetial: {},
      size: 0,
      comment: {
        currentPage: 1,
        pageSize: 1000,
        totalCount: 0,
        List: [],
        commentShow: false
      },
      peopleList: [],
      avatar: {
        circleUrl:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        size: "small"
      },
      ruleForm: {
        star: 0,
        text: "",
        id: ""
      },
      rules: {
        star: [
          { required: true, message: "请对活动进行星级评价", trigger: "blur" }
        ],
        text: [{ required: true, message: "请选择文字评价", trigger: "change" }]
      }
    };
  },
  methods: {
    isShow(str) {
      let result = this.followFieldDTOList.filter(item => {
        return item.field == str;
      });
      if (result.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    getCommont(id, index) {
      getCommont(id).then(res => {
        if (res.status) {
          let obj = {
            ...this.comment.list[index],
            isShow: true,
            list: res.data.pageList
          };
          this.comment.list.splice(index, 1, obj);
          this.$forceUpdate();
        }
      });
    },
    _comment: function() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let params = {
            content: this.ruleForm.text,
            score: this.ruleForm.star
          };
          if (this.commontId != "") params.id = this.commontId;
          comment(this.activityDetial.exhId, params).then(res => {
            if (res.status) {
              if (res.data) {
                this.$alert("评论成功。管理员审核后即会显示！", "提示", {
                  confirmButtonText: "确定",
                  callback: action => {
                    this.addComment();
                    this.getCommentList();
                  }
                });
              } else {
                this.addComment();
                this.getCommentList();
              }
            } else {
              this.$alert(res.message, "提示", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    addComment(id = "") {
      // console.log("内容id:", id);
      this.commontId = id;
      if (!this.comment.commentShow) {
        this.$nextTick(() => {
          this.$refs["ruleForm"].resetFields();
        });
      }
      this.comment.commentShow = !this.comment.commentShow;
    },
    getActivityDetial: function() {
      let params = {
        frontParams: [
          {
            cond: "eq",
            field: "id",
            value: this.$route.query.id
          }
        ]
      };
      orderDetial(params).then(data => {
        // console.log('预约详情内容：', data.data.pageList[0]);
        if (data.status) {
          this.activityDetial = data.content.pageList[0];
          getFollowData(this.activityDetial.exhId).then(res => {
            if (res.status) {
              this.max = res.data.followMax;
              this.followFieldDTOList = res.data.followFieldDTOList;
            } else {
              this.$alert("随行人员必填字段获取失败~", "提示", {
                confirmButtonText: "确定",
                callback: action => {
                  this.guide = before;
                }
              });
            }
            this.followFieldDTOList = res.data.followFieldDTOList;
          });
          this.getCommentList();
        } else {
          this.$alert("展览活动获取失败。请稍后再试", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
      });
    },
    getOrderTial: function() {
      findAllFollowPageByMakeId(this.$route.query.id).then(data => {
        if (data.status) {
          console.log("随行人员列表：", data.data.pageList);
          this.peopleList = data.content.pageList;
          this.size = data.content.totalCount;
        } else {
          this.$alert("预约信息获取失败。请稍后再试", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
      });
    },
    getCommentList: function(currentPage) {
      // console.log(currentPage, this.comment.currentPage);
      this.comment.currentPage =
        currentPage == undefined ? this.comment.currentPage : currentPage;
      let params = {
        currentPage: this.comment.currentPage,
        pageSize: this.comment.pageSize
      };
      getMyActivityComment(this.activityDetial.exhId, params).then(data => {
        if (data.status) {
          // console.log('评论内容:', data.data.pageList);
          this.comment.list = data.data.pageList;
          this.comment.list = this.comment.list.map(item => {
            return { ...item, list: [], isShow: false };
          });
          this.comment.totalCount = data.content.totalCount;
          this.$forceUpdate();
        } else {
          this.$alert("评论获取失败。请稍后再试", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
      });
    }
  },
  mounted() {
    this.getActivityDetial();
    this.getOrderTial();
  }
};
</script>
<style lang="less" scoped>
.indexActivity {
  height: 75vh;
  display: flex;
  flex-direction: column;
  .activityContent {
    background-color: #1a1a1ad1;
    padding: 15px;
    display: flex;
    display: flex;
    img {
      height: 140px;
      width: 210px;
    }
    > div {
      margin-left: 25px;
      color: #fffefc;
      h2 {
        margin-bottom: 10px;
      }
      > p {
        font-size: 13px;
        margin-bottom: 5px;
      }
      > div {
        font-size: 13px;
        display: flex;
        p:last-child {
          flex: 1;
          color: #8f8f8f;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .otherInfo {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    flex: 1;
    overflow: hidden;
    .orderDetial {
      width: 50%;
      display: flex;
      flex-direction: column;
      .time {
        display: flex;
        background-color: #1a1a1ad1;
        padding-left: 17px;
        padding-top: 20px;
        padding-bottom: 20px;
        color: white;
        font-size: 13px;
        p {
          margin-right: 30px;
          i {
            margin-right: 5px;
          }
          span:last-child {
            color: #878787;
            margin-left: 10px;
          }
        }
      }
      .peopleList {
        background-color: #1a1a1ad1;
        margin-top: 15px;
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        > .title {
          display: flex;
          justify-content: space-between;
          height: 40px;
          border-bottom: 1px solid #373636;
          align-items: center;
          padding-left: 17px;
          padding-right: 17px;
          font-size: 13px;
          color: white;
          > p:first-child::before {
            content: ".";
            background-color: #ae0c2a;
            color: #ae0c2a;
            width: 1px;
            margin-right: 7px;
          }
          .guideChange {
            height: 60%;
            background-color: #ae0c2a;
            color: white;
            outline: none;
            border: none;
            padding-left: 8px;
            padding-right: 8px;
            border-radius: 5px;
            margin-left: 10px;
            font-size: 12px;
          }
          div:first-child {
            display: flex;
            align-items: center;
            padding-left: 2%;
            p:first-child {
              color: white;
              font-size: 14px;
            }
            p:last-child {
              background-color: red;
              width: 18px;
              height: 18px;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;
              i {
                font-size: 12px;
                color: white;
              }
            }
          }
          div:last-child {
            display: flex;
            align-items: center;
            color: white;
            padding-right: 20px;
            p:first-child {
              font-size: 13px;
            }
          }
        }
        .content {
          width: 100%;
          margin: 0 auto;
          text-align: left;
          font-size: 14px;
          display: flex;
          flex-direction: column;
          flex: 1;
          overflow: hidden;
          .title {
            display: flex;
            height: 40px;
            align-items: center;
            width: 100%;
            background-color: #30302e;
            border-bottom: 1px solid #373636;
          }
          p {
            width: 25%;
            padding-left: 19px;
          }
          .items {
            flex: 1;
            overflow-y: scroll;
            .item {
              width: 100%;
              display: flex;
              height: 40px;
              align-items: center;
              color: white;
              p:last-child {
                color: #ae0c2a;
                i {
                  margin-right: 5px;
                }
              }
            }
            div:nth-child(even) {
              background-color: #30302e;
            }
          }
          div:first-child {
            color: #969696;
          }
        }
      }
    }
    .commentList {
      flex: 1;
      overflow: hidden;
      // background-color: #1a1a1ad1;
      margin-left: 15px;
      display: flex;
      flex-direction: column;

      .time {
        display: flex;
        background-color: #1a1a1ad1;
        padding-left: 17px;
        padding-top: 20px;
        padding-bottom: 20px;
        color: white;
        font-size: 13px;
        p {
          margin-right: 30px;
          i {
            margin-right: 5px;
          }
          span:last-child {
            color: #878787;
            margin-left: 10px;
          }
        }
      }

      .customPage {
        text-align: center;
        border-top: 1px solid #2d2c2c;
      }
      .title {
        margin-top: 15px;
        padding-bottom: 5px;
        padding-left: 10px;
        display: flex;
        justify-content: space-between;
        padding-right: 10px;
        padding-top: 10px;
        border-bottom: 1px solid #373636;
        background-color: #1a1a1ad1;
        padding-bottom: 10px;
        align-items: center;
        p {
          font-size: 13px;
          color: white;
          i {
            margin-left: 5px;
          }
        }
        p:first-child::before {
          content: ".";
          background-color: #ae0c2a;
          color: #ae0c2a;
          width: 1px;
          margin-right: 7px;
        }
        p:last-child {
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .content {
        background-color: #1a1a1ad1;
        overflow-y: scroll;
        flex: 1;
        .comment {
          margin: 0 auto;
          width: 95%;
          border-bottom: 1px solid #373636;
          padding-bottom: 15px;
          padding-top: 15px;
          .info {
            display: flex;
            font-size: 12px;
            color: white;
            span {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
            p {
              margin-right: 15px;
            }
          }
          .descri {
            display: flex;
            font-size: 12px;
            margin-top: 3px;
            color: white;
            p:first-child {
              line-height: 1.8;
            }
            p:last-child {
              color: #959595;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              line-clamp: 3;
              -webkit-box-orient: vertical;
              line-height: 1.7;
              flex: 1;
            }
          }
        }
      }
    }
  }
  .submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    button {
      height: 40px;
      width: 110px;
      background-color: black;
      border: 1px solid white;
      color: white;
      outline: none;
    }
    .order {
      background-color: #ae0c2a;
      border: 1px solid #ae0c2a;
      margin-left: 10px;
    }
  }
  .comment-time {
    display: flex;
    font-size: 12px;
    color: #aaa;
    margin-top: 3px;
    align-content: center;
    line-height: 12px;
    justify-content: flex-start;
    .commont-button {
      cursor: pointer;
      margin-left: 10px;
      font-weight: bold;
      color: white;
    }
  }
  .comment-list-wrap {
    cursor: pointer;
    font-size: 12px;
    color: white;
    margin-top: 5px;
  }
  .commont-children-item {
    margin-top: 10px;
    margin-left: 20px;
  }
}
</style>
<style scoped>
.dateContainer::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 0px;
}
.content .items::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}

.content .items::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}

.content .items::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}

.content .items::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}

.content .items::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}

.content .items::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}

.content .items::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}

.content .items {
  scrollbar-arrow-color: #f4ae21; /**/ /*三角箭头的颜色*/
  scrollbar-face-color: #333; /**/ /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666; /**/ /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666; /**/ /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999; /**/ /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**/ /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666; /**/ /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8; /**/ /*滚动条的基本颜色*/
}
.commentList::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 0px;
}
.commentList .content::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}

.commentList .content::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}

.commentList .content::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}

.commentList .content::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}

.commentList .content::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}

.commentList .content::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}

.commentList .content::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}

.commentList .content {
  scrollbar-arrow-color: #f4ae21; /**/ /*三角箭头的颜色*/
  scrollbar-face-color: #333; /**/ /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666; /**/ /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666; /**/ /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999; /**/ /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666; /**/ /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666; /**/ /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8; /**/ /*滚动条的基本颜色*/
}
.searchItem .el-input .el-input__inner {
  height: 35px;
}
</style>
<style>
.el-pagination {
  padding: 0;
}
.el-pagination .el-pager li {
  background-color: #fff0 !important;
  color: white;
}
.el-pagination .el-pager li.active {
  color: #ae0c2a;
  cursor: default;
}
.el-pagination button {
  background-color: #fff0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/single/orderDetial.vue